import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { combinationPaths } from "./AdminSettings"; // Import the combination paths

// Add the combination path for NC Educator
combinationPaths["NC-Educator-5th-science"] = "/educator/nc/nc-5th-educator-science";
combinationPaths["NC-Educator-4th-science"] = "/educator/nc/nc-4th-educator-science";
combinationPaths["NC-Educator-3rd-science"] = "/educator/nc/nc-3rd-educator-science";
combinationPaths["NC-Educator-2nd-science"] = "/educator/nc/nc-2nd-educator-science";
combinationPaths["NC-Educator-1st-science"] = "/educator/nc/nc-1st-educator-science";
combinationPaths["NC-Educator-5th-math"] = "/educator/nc/nc-5th-educator-math";
combinationPaths["NC-Educator-4th-math"] = "/educator/nc/nc-4th-educator-math";
combinationPaths["NC-Educator-3rd-math"] = "/educator/nc/nc-3rd-educator-math";
combinationPaths["NC-Educator-2nd-math"] = "/educator/nc/nc-2nd-educator-math";
combinationPaths["NC-Educator-1st-math"] = "/educator/nc/nc-1st-educator-math";
combinationPaths["NC-Educator-5th-socialstudies"] = "/educator/nc/nc-5th-educator-socialstudies";
combinationPaths["NC-Educator-4th-socialstudies"] = "/educator/nc/nc-4th-educator-socialstudies";
combinationPaths["NC-Educator-3rd-socialstudies"] = "/educator/nc/nc-3rd-educator-socialstudies";
combinationPaths["NC-Educator-2nd-socialstudies"] = "/educator/nc/nc-2nd-educator-socialstudies";
combinationPaths["NC-Educator-1st-socialstudies"] = "/educator/nc/nc-1st-educator-socialstudies";
combinationPaths["NC-Educator-5th-other"] = "/educator/nc/nc-5th-educator-other";
combinationPaths["NC-Educator-4th-other"] = "/educator/nc/nc-4th-educator-other";
combinationPaths["NC-Educator-3rd-other"] = "/educator/nc/nc-3rd-educator-other";
combinationPaths["NC-Educator-2nd-other"] = "/educator/nc/nc-2nd-educator-other";
combinationPaths["NC-Educator-1st-other"] = "/educator/nc/nc-1st-educator-other";
// Add the combination path for NC Student
combinationPaths["NC-Student-5th-science"] = "/student/nc/nc-5th-student-science";
combinationPaths["NC-Student-4th-science"] = "/student/nc/nc-4th-student-science";
combinationPaths["NC-Student-3rd-science"] = "/student/nc/nc-3rd-student-science";
combinationPaths["NC-Student-2nd-science"] = "/student/nc/nc-2nd-student-science";
combinationPaths["NC-Student-1st-science"] = "/student/nc/nc-1st-student-science";
combinationPaths["NC-Student-5th-math"] = "/student/nc/nc-5th-student-math";
combinationPaths["NC-Student-4th-math"] = "/student/nc/nc-4th-student-math";
combinationPaths["NC-Student-3rd-math"] = "/student/nc/nc-3rd-student-math";
combinationPaths["NC-Student-2nd-math"] = "/student/nc/nc-2nd-student-math";
combinationPaths["NC-Student-1st-math"] = "/student/nc/nc-1st-student-math";
combinationPaths["NC-Student-5th-socialstudies"] = "/student/nc/nc-5th-student-socialstudies";
combinationPaths["NC-Student-4th-socialstudies"] = "/student/nc/nc-4th-student-socialstudies";
combinationPaths["NC-Student-3rd-socialstudies"] = "/student/nc/nc-3rd-student-socialstudies";
combinationPaths["NC-Student-2nd-socialstudies"] = "/student/nc/nc-2nd-student-socialstudies";
combinationPaths["NC-Student-1st-socialstudies"] = "/student/nc/nc-1st-student-socialstudies";
combinationPaths["NC-Student-5th-other"] = "/student/nc/nc-5th-student-other";
combinationPaths["NC-Student-4th-other"] = "/student/nc/nc-4th-student-other";
combinationPaths["NC-Student-3rd-other"] = "/student/nc/nc-3rd-student-other";
combinationPaths["NC-Student-2nd-other"] = "/student/nc/nc-2nd-student-other";
combinationPaths["NC-Student-1st-other"] = "/student/nc/nc-1st-student-other";
// Add the combination path for VA Educator
combinationPaths["VA-Educator-12th-science"] = "/educator/va/va-12th-educator-science";
combinationPaths["VA-Educator-5th-science"] = "/educator/va/va-5th-educator-science";
combinationPaths["VA-Educator-4th-science"] = "/educator/va/va-4th-educator-science";
combinationPaths["VA-Educator-3rd-science"] = "/educator/va/va-3rd-educator-science";
combinationPaths["VA-Educator-2nd-science"] = "/educator/va/va-2nd-educator-science";
combinationPaths["VA-Educator-1st-science"] = "/educator/va/va-1st-educator-science";
combinationPaths["VA-Educator-12th-math"] = "/educator/va/va-12th-educator-math";
combinationPaths["VA-Educator-5th-math"] = "/educator/va/va-5th-educator-math";
combinationPaths["VA-Educator-4th-math"] = "/educator/va/va-4th-educator-math";
combinationPaths["VA-Educator-3rd-math"] = "/educator/va/va-3rd-educator-math";
combinationPaths["VA-Educator-2nd-math"] = "/educator/va/va-2nd-educator-math";
combinationPaths["VA-Educator-1st-math"] = "/educator/va/va-1st-educator-math";
combinationPaths["VA-Educator-12th-socialstudies"] = "/educator/va/va-12th-educator-socialstudies";
combinationPaths["VA-Educator-5th-socialstudies"] = "/educator/va/va-5th-educator-socialstudies";
combinationPaths["VA-Educator-4th-socialstudies"] = "/educator/va/va-4th-educator-socialstudies";
combinationPaths["VA-Educator-3rd-socialstudies"] = "/educator/va/va-3rd-educator-socialstudies";
combinationPaths["VA-Educator-2nd-socialstudies"] = "/educator/va/va-2nd-educator-socialstudies";
combinationPaths["VA-Educator-1st-socialstudies"] = "/educator/va/va-1st-educator-socialstudies";
combinationPaths["VA-Educator-12th-other"] = "/educator/va/va-12th-educator-other";
combinationPaths["VA-Educator-5th-other"] = "/educator/va/va-5th-educator-other";
combinationPaths["VA-Educator-4th-other"] = "/educator/va/va-4th-educator-other";
combinationPaths["VA-Educator-3rd-other"] = "/educator/va/va-3rd-educator-other";
combinationPaths["VA-Educator-2nd-other"] = "/educator/va/va-2nd-educator-other";
combinationPaths["VA-Educator-1st-other"] = "/educator/va/va-1st-educator-other";
// Add the combination path for VA Student
combinationPaths["VA-Student-12th-science"] = "/student/va/va-12th-student-science";
combinationPaths["VA-Student-5th-science"] = "/student/va/va-5th-student-science";
combinationPaths["VA-Student-4th-science"] = "/student/va/va-4th-student-science";
combinationPaths["VA-Student-3rd-science"] = "/student/va/va-3rd-student-science";
combinationPaths["VA-Student-2nd-science"] = "/student/va/va-2nd-student-science";
combinationPaths["VA-Student-1st-science"] = "/student/va/va-1st-student-science";
combinationPaths["VA-Student-12th-math"] = "/student/va/va-12th-student-math";
combinationPaths["VA-Student-5th-math"] = "/student/va/va-5th-student-math";
combinationPaths["VA-Student-4th-math"] = "/student/va/va-4th-student-math";
combinationPaths["VA-Student-3rd-math"] = "/student/va/va-3rd-student-math";
combinationPaths["VA-Student-2nd-math"] = "/student/va/va-2nd-student-math";
combinationPaths["VA-Student-1st-math"] = "/student/va/va-1st-student-math";
combinationPaths["VA-Student-12th-socialstudies"] = "/student/va/va-12th-student-socialstudies";
combinationPaths["VA-Student-5th-socialstudies"] = "/student/va/va-5th-student-socialstudies";
combinationPaths["VA-Student-4th-socialstudies"] = "/student/va/va-4th-student-socialstudies";
combinationPaths["VA-Student-3rd-socialstudies"] = "/student/va/va-3rd-student-socialstudies";
combinationPaths["VA-Student-2nd-socialstudies"] = "/student/va/va-2nd-student-socialstudies";
combinationPaths["VA-Student-1st-socialstudies"] = "/student/va/va-1st-student-socialstudies";
combinationPaths["VA-Student-12th-other"] = "/student/va/va-12th-student-other";
combinationPaths["VA-Student-5th-other"] = "/student/va/va-5th-student-other";
combinationPaths["VA-Student-4th-other"] = "/student/va/va-4th-student-other";
combinationPaths["VA-Student-3rd-other"] = "/student/va/va-3rd-student-other";
combinationPaths["VA-Student-2nd-other"] = "/student/va/va-2nd-student-other";
combinationPaths["VA-Student-1st-other"] = "/student/va/va-1st-student-other";
// Add the combination path for NY Educator
combinationPaths["NY-Educator-5th-science"] = "/educator/ny-5th-educator-science";
combinationPaths["NY-Educator-4th-science"] = "/educator/ny-4th-educator-science";
combinationPaths["NY-Educator-3rd-science"] = "/educator/ny-3rd-educator-science";
combinationPaths["NY-Educator-2nd-science"] = "/educator/ny-2nd-educator-science";
combinationPaths["NY-Educator-1st-science"] = "/educator/ny-1st-educator-science";
combinationPaths["NY-Educator-5th-math"] = "/educator/ny-5th-educator-math";
combinationPaths["NY-Educator-4th-math"] = "/educator/ny-4th-educator-math";
combinationPaths["NY-Educator-3rd-math"] = "/educator/ny-3rd-educator-math";
combinationPaths["NY-Educator-2nd-math"] = "/educator/ny-2nd-educator-math";
combinationPaths["NY-Educator-1st-math"] = "/educator/ny-1st-educator-math";
combinationPaths["NY-Educator-5th-socialstudies"] = "/educator/ny-5th-educator-socialstudies";
combinationPaths["NY-Educator-4th-socialstudies"] = "/educator/ny-4th-educator-socialstudies";
combinationPaths["NY-Educator-3rd-socialstudies"] = "/educator/ny-3rd-educator-socialstudies";
combinationPaths["NY-Educator-2nd-socialstudies"] = "/educator/ny-2nd-educator-socialstudies";
combinationPaths["NY-Educator-1st-socialstudies"] = "/educator/ny-1st-educator-socialstudies";
combinationPaths["NY-Educator-5th-other"] = "/educator/ny-5th-educator-other";
combinationPaths["NY-Educator-4th-other"] = "/educator/ny-4th-educator-other";
combinationPaths["NY-Educator-3rd-other"] = "/educator/ny-3rd-educator-other";
combinationPaths["NY-Educator-2nd-other"] = "/educator/ny-2nd-educator-other";
combinationPaths["NY-Educator-1st-other"] = "/educator/ny-1st-educator-other";
// Add the combination path for NY Student
combinationPaths["NY-Student-5th-science"] = "/student/ny-5th-student-science";
combinationPaths["NY-Student-4th-science"] = "/student/ny-4th-student-science";
combinationPaths["NY-Student-3rd-science"] = "/student/ny-3rd-student-science";
combinationPaths["NY-Student-2nd-science"] = "/student/ny-2nd-student-science";
combinationPaths["NY-Student-1st-science"] = "/student/ny-1st-student-science";
combinationPaths["NY-Student-5th-math"] = "/student/ny-5th-student-math";
combinationPaths["NY-Student-4th-math"] = "/student/ny-4th-student-math";
combinationPaths["NY-Student-3rd-math"] = "/student/ny-3rd-student-math";
combinationPaths["NY-Student-2nd-math"] = "/student/ny-2nd-student-math";
combinationPaths["NY-Student-1st-math"] = "/student/ny-1st-student-math";
combinationPaths["NY-Student-5th-socialstudies"] = "/student/ny-5th-student-socialstudies";
combinationPaths["NY-Student-4th-socialstudies"] = "/student/ny-4th-student-socialstudies";
combinationPaths["NY-Student-3rd-socialstudies"] = "/student/ny-3rd-student-socialstudies";
combinationPaths["NY-Student-2nd-socialstudies"] = "/student/ny-2nd-student-socialstudies";
combinationPaths["NY-Student-1st-socialstudies"] = "/student/ny-1st-student-socialstudies";
combinationPaths["NY-Student-5th-other"] = "/student/ny-5th-student-other";
combinationPaths["NY-Student-4th-other"] = "/student/ny-4th-student-other";
combinationPaths["NY-Student-3rd-other"] = "/student/ny-3rd-student-other";
combinationPaths["NY-Student-2nd-other"] = "/student/ny-2nd-student-other";
combinationPaths["NY-Student-1st-other"] = "/student/ny-1st-student-other";
// Add the combination path for DC Educator
combinationPaths["DC-Educator-5th-science"] = "/educator/dc-5th-educator-science";
combinationPaths["DC-Educator-4th-science"] = "/educator/dc-4th-educator-science";
combinationPaths["DC-Educator-3rd-science"] = "/educator/dc-3rd-educator-science";
combinationPaths["DC-Educator-2nd-science"] = "/educator/dc-2nd-educator-science";
combinationPaths["DC-Educator-1st-science"] = "/educator/dc-1st-educator-science";
combinationPaths["DC-Educator-5th-math"] = "/educator/dc-5th-educator-math";
combinationPaths["DC-Educator-4th-math"] = "/educator/dc-4th-educator-math";
combinationPaths["DC-Educator-3rd-math"] = "/educator/dc-3rd-educator-math";
combinationPaths["DC-Educator-2nd-math"] = "/educator/dc-2nd-educator-math";
combinationPaths["DC-Educator-1st-math"] = "/educator/dc-1st-educator-math";
combinationPaths["DC-Educator-5th-socialstudies"] = "/educator/dc-5th-educator-socialstudies";
combinationPaths["DC-Educator-4th-socialstudies"] = "/educator/dc-4th-educator-socialstudies";
combinationPaths["DC-Educator-3rd-socialstudies"] = "/educator/dc-3rd-educator-socialstudies";
combinationPaths["DC-Educator-2nd-socialstudies"] = "/educator/dc-2nd-educator-socialstudies";
combinationPaths["DC-Educator-1st-socialstudies"] = "/educator/dc-1st-educator-socialstudies";
combinationPaths["DC-Educator-5th-other"] = "/educator/dc-5th-educator-other";
combinationPaths["DC-Educator-4th-other"] = "/educator/dc-4th-educator-other";
combinationPaths["DC-Educator-3rd-other"] = "/educator/dc-3rd-educator-other";
combinationPaths["DC-Educator-2nd-other"] = "/educator/dc-2nd-educator-other";
combinationPaths["DC-Educator-1st-other"] = "/educator/dc-1st-educator-other";
// Add the combination path for DC Student
combinationPaths["DC-Student-5th-science"] = "/student/dc-5th-student-science";
combinationPaths["DC-Student-4th-science"] = "/student/dc-4th-student-science";
combinationPaths["DC-Student-3rd-science"] = "/student/dc-3rd-student-science";
combinationPaths["DC-Student-2nd-science"] = "/student/dc-2nd-student-science";
combinationPaths["DC-Student-1st-science"] = "/student/dc-1st-student-science";
combinationPaths["DC-Student-5th-math"] = "/student/dc-5th-student-math";
combinationPaths["DC-Student-4th-math"] = "/student/dc-4th-student-math";
combinationPaths["DC-Student-3rd-math"] = "/student/dc-3rd-student-math";
combinationPaths["DC-Student-2nd-math"] = "/student/dc-2nd-student-math";
combinationPaths["DC-Student-1st-math"] = "/student/dc-1st-student-math";
combinationPaths["DC-Student-5th-socialstudies"] = "/student/dc-5th-student-socialstudies";
combinationPaths["DC-Student-4th-socialstudies"] = "/student/dc-4th-student-socialstudies";
combinationPaths["DC-Student-3rd-socialstudies"] = "/student/dc-3rd-student-socialstudies";
combinationPaths["DC-Student-2nd-socialstudies"] = "/student/dc-2nd-student-socialstudies";
combinationPaths["DC-Student-1st-socialstudies"] = "/student/dc-1st-student-socialstudies";
combinationPaths["DC-Student-5th-other"] = "/student/dc-5th-student-other";
combinationPaths["DC-Student-4th-other"] = "/student/dc-4th-student-other";
combinationPaths["DC-Student-3rd-other"] = "/student/dc-3rd-student-other";
combinationPaths["DC-Student-2nd-other"] = "/student/dc-2nd-student-other";
combinationPaths["DC-Student-1st-other"] = "/student/dc-1st-student-other";
// Add the combination path for GA Educator
combinationPaths["GA-Educator-5th-science"] = "/educator/ga/ga-5th-educator-science";
combinationPaths["GA-Educator-4th-science"] = "/educator/ga/ga-4th-educator-science";
combinationPaths["GA-Educator-3rd-science"] = "/educator/ga/ga-3rd-educator-science";
combinationPaths["GA-Educator-2nd-science"] = "/educator/ga/ga-2nd-educator-science";
combinationPaths["GA-Educator-1st-science"] = "/educator/ga/ga-1st-educator-science";
combinationPaths["GA-Educator-5th-math"] = "/educator/ga/ga-5th-educator-math";
combinationPaths["GA-Educator-4th-math"] = "/educator/ga/ga-4th-educator-math";
combinationPaths["GA-Educator-3rd-math"] = "/educator/ga/ga-3rd-educator-math";
combinationPaths["GA-Educator-2nd-math"] = "/educator/ga/ga-2nd-educator-math";
combinationPaths["GA-Educator-1st-math"] = "/educator/ga/ga-1st-educator-math";
combinationPaths["GA-Educator-5th-socialstudies"] = "/educator/ga/ga-5th-educator-socialstudies";
combinationPaths["GA-Educator-4th-socialstudies"] = "/educator/ga/ga-4th-educator-socialstudies";
combinationPaths["GA-Educator-3rd-socialstudies"] = "/educator/ga/ga-3rd-educator-socialstudies";
combinationPaths["GA-Educator-2nd-socialstudies"] = "/educator/ga/ga-2nd-educator-socialstudies";
combinationPaths["GA-Educator-1st-socialstudies"] = "/educator/ga/ga-1st-educator-socialstudies";
combinationPaths["GA-Educator-5th-other"] = "/educator/ga/ga-5th-educator-other";
combinationPaths["GA-Educator-4th-other"] = "/educator/ga/ga-4th-educator-other";
combinationPaths["GA-Educator-3rd-other"] = "/educator/ga/ga-3rd-educator-other";
combinationPaths["GA-Educator-2nd-other"] = "/educator/ga/ga-2nd-educator-other";
combinationPaths["GA-Educator-1st-other"] = "/educator/ga/ga-1st-educator-other";
// Add the combination path for GA Student
combinationPaths["GA-Student-5th-science"] = "/student/ga/ga-5th-student-science";
combinationPaths["GA-Student-4th-science"] = "/student/ga/ga-4th-student-science";
combinationPaths["GA-Student-3rd-science"] = "/student/ga/ga-3rd-student-science";
combinationPaths["GA-Student-2nd-science"] = "/student/ga/ga-2nd-student-science";
combinationPaths["GA-Student-1st-science"] = "/student/ga/ga-1st-student-science";
combinationPaths["GA-Student-5th-math"] = "/student/ga/ga-5th-student-math";
combinationPaths["GA-Student-4th-math"] = "/student/ga/ga-4th-student-math";
combinationPaths["GA-Student-3rd-math"] = "/student/ga/ga-3rd-student-math";
combinationPaths["GA-Student-2nd-math"] = "/student/ga/ga-2nd-student-math";
combinationPaths["GA-Student-1st-math"] = "/student/ga/ga-1st-student-math";
combinationPaths["GA-Student-5th-socialstudies"] = "/student/ga/ga-5th-student-socialstudies";
combinationPaths["GA-Student-4th-socialstudies"] = "/student/ga/ga-4th-student-socialstudies";
combinationPaths["GA-Student-3rd-socialstudies"] = "/student/ga/ga-3rd-student-socialstudies";
combinationPaths["GA-Student-2nd-socialstudies"] = "/student/ga/ga-2nd-student-socialstudies";
combinationPaths["GA-Student-1st-socialstudies"] = "/student/ga/ga-1st-student-socialstudies";
combinationPaths["GA-Student-5th-other"] = "/student/ga/ga-5th-student-other";
combinationPaths["GA-Student-4th-other"] = "/student/ga/ga-4th-student-other";
combinationPaths["GA-Student-3rd-other"] = "/student/ga/ga-3rd-student-other";
combinationPaths["GA-Student-2nd-other"] = "/student/ga/ga-2nd-student-other";
combinationPaths["GA-Student-1st-other"] = "/student/ga/ga-1st-student-other";

// Add the combination path for CA Educator
combinationPaths["CA-Educator-5th-science"] = "/educator/ca/ca-5th-educator-science";
combinationPaths["CA-Educator-4th-science"] = "/educator/ca/ca-4th-educator-science";
combinationPaths["CA-Educator-3rd-science"] = "/educator/ca/ca-3rd-educator-science";
combinationPaths["CA-Educator-2nd-science"] = "/educator/ca/ca-2nd-educator-science";
combinationPaths["CA-Educator-1st-science"] = "/educator/ca/ca-1st-educator-science";
combinationPaths["CA-Educator-5th-math"] = "/educator/ca/ca-5th-educator-math";
combinationPaths["CA-Educator-4th-math"] = "/educator/ca/ca-4th-educator-math";
combinationPaths["CA-Educator-3rd-math"] = "/educator/ca/ca-3rd-educator-math";
combinationPaths["CA-Educator-2nd-math"] = "/educator/ca/ca-2nd-educator-math";
combinationPaths["CA-Educator-1st-math"] = "/educator/ca/ca-1st-educator-math";
combinationPaths["CA-Educator-5th-socialstudies"] = "/educator/ca/ca-5th-educator-socialstudies";
combinationPaths["CA-Educator-4th-socialstudies"] = "/educator/ca/ca-4th-educator-socialstudies";
combinationPaths["CA-Educator-3rd-socialstudies"] = "/educator/ca/ca-3rd-educator-socialstudies";
combinationPaths["CA-Educator-2nd-socialstudies"] = "/educator/ca/ca-2nd-educator-socialstudies";
combinationPaths["CA-Educator-1st-socialstudies"] = "/educator/ca/ca-1st-educator-socialstudies";
combinationPaths["CA-Educator-5th-other"] = "/educator/ca/ca-5th-educator-other";
combinationPaths["CA-Educator-4th-other"] = "/educator/ca/ca-4th-educator-other";
combinationPaths["CA-Educator-3rd-other"] = "/educator/ca/ca-3rd-educator-other";
combinationPaths["CA-Educator-2nd-other"] = "/educator/ca/ca-2nd-educator-other";
combinationPaths["CA-Educator-1st-other"] = "/educator/ca/ca-1st-educator-other";

// Add the combination path for CA Student
combinationPaths["CA-Student-5th-science"] = "/student/ca/ca-5th-student-science";
combinationPaths["CA-Student-4th-science"] = "/student/ca/ca-4th-student-science";
combinationPaths["CA-Student-3rd-science"] = "/student/ca/ca-3rd-student-science";
combinationPaths["CA-Student-2nd-science"] = "/student/ca/ca-2nd-student-science";
combinationPaths["CA-Student-1st-science"] = "/student/ca/ca-1st-student-science";
combinationPaths["CA-Student-5th-math"] = "/student/ca/ca-5th-student-math";
combinationPaths["CA-Student-4th-math"] = "/student/ca/ca-4th-student-math";
combinationPaths["CA-Student-3rd-math"] = "/student/ca/ca-3rd-student-math";
combinationPaths["CA-Student-2nd-math"] = "/student/ca/ca-2nd-student-math";
combinationPaths["CA-Student-1st-math"] = "/student/ca/ca-1st-student-math";
combinationPaths["CA-Student-5th-socialstudies"] = "/student/ca/ca-5th-student-socialstudies";
combinationPaths["CA-Student-4th-socialstudies"] = "/student/ca/ca-4th-student-socialstudies";
combinationPaths["CA-Student-3rd-socialstudies"] = "/student/ca/ca-3rd-student-socialstudies";
combinationPaths["CA-Student-2nd-socialstudies"] = "/student/ca/ca-2nd-student-socialstudies";
combinationPaths["CA-Student-1st-socialstudies"] = "/student/ca/ca-1st-student-socialstudies";
combinationPaths["CA-Student-5th-other"] = "/student/ca/ca-5th-student-other";
combinationPaths["CA-Student-4th-other"] = "/student/ca/ca-4th-student-other";
combinationPaths["CA-Student-3rd-other"] = "/student/ca/ca-3rd-student-other";
combinationPaths["CA-Student-2nd-other"] = "/student/ca/ca-2nd-student-other";
combinationPaths["CA-Student-1st-other"] = "/student/ca/ca-1st-student-other";

// Add the combination path for ALL Educator
combinationPaths["ALL-Educator-ALL-science"] = "/educator/all-all-educator-science";
combinationPaths["ALL-Educator-ALL-math"] = "/educator/all-all-educator-math";
combinationPaths["ALL-Educator-ALL-socialstudies"] = "/educator/all-all-educator-socialstudies";
combinationPaths["ALL-Educator-ALL-other"] = "/educator/all-all-educator-other";
combinationPaths["SLIDESHOW-Educator-SLIDESHOW-other"] = "/educator/slideshow";
combinationPaths["SLIDEUPLOADER-Educator-SLIDEUPLOADER-other"] = "/educator/slideuploader";

const AdminTools = () => {
  const navigate = useNavigate(); // Ensure this is used within a Router context

  const states = [
    "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA",
    "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD",
    "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NC", "NH", "NJ",
    "NM", "NY", "NV", "ND", "OH", "OK", "OR", "PA", "RI", "SC",
    "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY",
    "DC", "ALL",
  ];
  const grades = ["ALL", "1st", "2nd", "3rd", "4th", "5th", "6th", "7th", "8th", "9th", "10th", "11th", "12th", "14th", "15th", "16th"];
  const subjects = ["science", "socialstudies", "math", "other", "classroom"];
  const views = ["Student", "Educator"];

  const [selectedState, setSelectedState] = useState(null);
  const [selectedView, setSelectedView] = useState(null);
  const [selectedGrade, setSelectedGrade] = useState(null);
  const [selectedSubject, setSelectedSubject] = useState(null);

  const handleStateClick = (state) => {
    setSelectedState(state);
    setSelectedView(null); // Reset view when a new state is selected
    setSelectedGrade(null); // Reset grade when a new state is selected
    setSelectedSubject(null); // Reset subject when a new state is selected
  };

  const handleViewClick = (view) => {
    setSelectedView(view);
    setSelectedSubject(null); // Reset subject when a new view is selected
  };

  const handleGradeClick = (grade) => {
    setSelectedGrade(grade);
    setSelectedView(null); // Reset view when a new grade is selected
    setSelectedSubject(null); // Reset subject when a new grade is selected
  };

  const handleSubjectClick = (subject) => {
    setSelectedSubject(subject);
    const combinationKey = `${selectedState}-${selectedView}-${selectedGrade}-${subject}`;
    const path = combinationPaths[combinationKey];
    if (path) {
      navigate(path); // This should now work!
    } else {
      alert("Combination not found. Please make sure to select a valid combination.");
    }
};


  return (
    <div style={{ padding: "20px", textAlign: "center" }}>
      <style>{`
        .admin-tool-btn {
          transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;
        }
        .admin-tool-btn:hover {
          transform: translateY(-2px) scale(1.05);
          filter: brightness(1.05);
        }
      `}</style>

      {/* Return to Admin Dashboard Button */}
      <button
        className="admin-tool-btn"
        onClick={() => navigate("/admin")}
        style={{
          padding: "15px 30px",
          fontSize: "18px",
          backgroundColor: "#007bff",
          color: "#fff",
          border: "none",
          borderRadius: "10px",
          cursor: "pointer",
          marginBottom: "20px",
          marginRight: "10px", // Add spacing between buttons
          boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.2)",
        }}
      >
        Return to Admin Dashboard
      </button>

      {/* Memory Match Game Tools Button */}
      <button
        className="admin-tool-btn"
        onClick={() => navigate("./MemoryMatchTools")} // Correct relative path
        style={{
          padding: "15px 30px",
          fontSize: "18px",
          backgroundColor: "#ff9800", // Orange color
          color: "#fff",
          border: "none",
          borderRadius: "10px",
          cursor: "pointer",
          marginBottom: "20px",
          boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.2)",
        }}
      >
        Memory Match Game Tools
      </button>

      <h1>Manage Tools</h1>
      <h2>Select a State</h2>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(10, 1fr)",
          gap: "10px",
          justifyContent: "center",
        }}
      >
        {states.map((state) => (
          <button
            key={state}
            className="admin-tool-btn"
            onClick={() => handleStateClick(state)}
            style={{
              padding: "10px",
              backgroundColor: selectedState === state ? "#d4d4d4" : "#f5f5f5",
              color: selectedState === state ? "#000" : "#555",
              border: "1px solid #bbb",
              borderRadius: "5px",
              cursor: "pointer",
              boxShadow:
                "inset -1px -1px 3px rgba(255, 255, 255, 0.8), inset 2px 2px 5px rgba(0, 0, 0, 0.1)",
            }}
          >
            {state}
          </button>
        ))}
      </div>

      {selectedState && (
        <>
          <h2>Select a Grade for {selectedState}</h2>
          <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: "10px" }}>
            {grades.map((grade) => (
              <button
                key={grade}
                className="admin-tool-btn"
                onClick={() => handleGradeClick(grade)}
                style={{
                  padding: "10px",
                  backgroundColor: selectedGrade === grade ? "#d4d4d4" : "#f5f5f5",
                  color: selectedGrade === grade ? "#000" : "#555",
                  border: "1px solid #bbb",
                  borderRadius: "5px",
                  cursor: "pointer",
                  boxShadow:
                    "inset -1px -1px 3px rgba(255, 255, 255, 0.8), inset 2px 2px 5px rgba(0, 0, 0, 0.1)",
                }}
              >
                {grade}
              </button>
            ))}
          </div>
        </>
      )}

      {selectedGrade && (
        <>
          <h2>Select a View for {selectedGrade} in {selectedState}</h2>
          <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
            {views.map((view) => (
              <button
                key={view}
                className="admin-tool-btn"
                onClick={() => handleViewClick(view)}
                style={{
                  padding: "10px",
                  backgroundColor: selectedView === view ? "#d4d4d4" : "#f5f5f5",
                  color: selectedView === view ? "#000" : "#555",
                  border: "1px solid #bbb",
                  borderRadius: "5px",
                  cursor: "pointer",
                  boxShadow:
                    "inset -1px -1px 3px rgba(255, 255, 255, 0.8), inset 2px 2px 5px rgba(0, 0, 0, 0.1)",
                }}
              >
                {view}
              </button>
            ))}
          </div>
        </>
      )}

      {selectedView && (
        <>
          <h2>Select a Subject for {selectedView} in {selectedState}</h2>
          <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: "10px" }}>
            {subjects.map((subject) => (
              <button
                key={subject}
                className="admin-tool-btn"
                onClick={() => handleSubjectClick(subject)}
                style={{
                  padding: "10px",
                  backgroundColor: selectedSubject === subject ? "#d4d4d4" : "#f5f5f5",
                  color: selectedSubject === subject ? "#000" : "#555",
                  border: "1px solid #bbb",
                  borderRadius: "5px",
                  cursor: "pointer",
                  boxShadow:
                    "inset -1px -1px 3px rgba(255, 255, 255, 0.8), inset 2px 2px 5px rgba(0, 0, 0, 0.1)",
                }}
              >
                {subject.charAt(0).toUpperCase() + subject.slice(1)}
              </button>
            ))}
          </div>
        </>
      )}

      <div style={{ padding: "20px" }}>
        <h2>Admin Tools</h2>
        <button
          className="admin-tool-btn"
          onClick={() => navigate("/educator/slideshow")}
          style={{ margin: "10px", padding: "10px 20px" }}
        >
          Go to SlideShow
        </button>
        <button
          className="admin-tool-btn"
          onClick={() => navigate("/educator/slideuploader")}
          style={{ margin: "10px", padding: "10px 20px" }}
        >
          Go to SlideUploader
        </button>
      </div>
    </div>
  );
};

export default AdminTools;
